import { render, staticRenderFns } from "./fila_compromisso.vue?vue&type=template&id=0065bb7a&scoped=true&"
import script from "./fila_compromisso.vue?vue&type=script&lang=js&"
export * from "./fila_compromisso.vue?vue&type=script&lang=js&"
import style0 from "./fila_compromisso.vue?vue&type=style&index=0&id=0065bb7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0065bb7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardText,VCardTitle,VList,VListItem,VListItemGroup})
